import React from "react";
import { Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Header from "go-app/components/Header";
import { selectOrganization } from "../../../../../../../services/organizations/selectors";

const SubscriptionsReadOnlyDisplay = () => {
	const organization = useSelector(selectOrganization);
	const { t } = useTranslation();
	const history = useHistory();
	const loc = window.location.href;

	const goBack = () => {
		if (loc.includes("/subscriptions/edit")) history.push(`/${organization.id}/subscriptions`);
		history.push(`/${organization.id}`);
	};

	return (
		<>
			<Header back={goBack} title={t("common.word.subscriptions")} />
			<div className={"content-preview"}>
				<Alert variant={"danger"}>
					<span className={"me-1"}>{t("modules.subscription.field.subscriptions_read_only.title")}</span>
				</Alert>
			</div>
		</>
	);
};

export default SubscriptionsReadOnlyDisplay;
